import React from 'react';
import './Feedback.css';

export default function Feedback() {
  return (
    <div className="feedback-container">
      <div className="feedback-frame-wrapper">
        <iframe
          title="Old Mutual Ghana Feedback Form"
          src="https://forms.office.com/pages/responsepage.aspx?id=cxb1MIj_PkK-4ztXIDM451JkibZucjBErx6JRfgm359UQ1ZGUzdLUThKQUtLR0JFRFg2QVJaRU8zRS4u&route=shorturl"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ borderRadius: '16px' }}
          allowFullScreen
        />
      </div>
    </div>
  );
}